export default defineNuxtPlugin((nuxtApp) => {
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  nuxtApp.provide("capitalize", capitalize)
})
